module.exports = __webpack_public_path__ + "static/media/meet-the-team-1.a4e5d73e.png";